module.exports = __webpack_public_path__ + "static/media/country_pl.2cec7ba1.webp";